import React, { useEffect } from 'react'
import NavbarTop from '../components/global/NavbarTop'

import CaseStudiesFinancialContent from '../components/CaseStudies/CaseStudiesFinancialContent'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { selectLanguage } from './../redux/language/selector';

const CaseStudiesFinancial = () => {

  const {t} = useTranslation()

  const language = useSelector(selectLanguage)

  useEffect(() => {
    document.title = t('case-studies-financial-page.case-studies-financial-page-title')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[language])

  return (
    <>
        <NavbarTop/>
        <CaseStudiesFinancialContent/>
    </>
  )
}

export default CaseStudiesFinancial